const triggerBtn = document.querySelector('[data-connect-trigger]')
const panel = document.querySelector('[data-connect-panel]')
const closeBtn = document.querySelector('[data-connect-close]')

triggerBtn?.addEventListener('click', () => {
    if (panel) panel.dataset.connectPanel = 'showed'
})

closeBtn?.addEventListener('click', () => {
    if (panel) panel.dataset.connectPanel = 'hidden'
})

panel?.addEventListener('click', (evt) => {
    const panelBody = evt.target.closest('.connect-panel__body')
    if (panelBody) return
    if (panel) panel.dataset.connectPanel = 'hidden'
})
